'use server';

/**
 * Kontora BFF – Logout Server Action
 */

import { cookies } from 'next/headers';
import { redirect } from 'next/navigation';
import { callInternalApi } from '../api-client/internal-api-client';
import { clearCsrfCookie } from '../csrf/csrf.helper';
import { clearSessionCookie, COOKIE_NAME } from '../cookies/session-cookie';

export async function logoutAction(): Promise<void> {
  const cookieStore = await cookies();
  const sessionToken = cookieStore.get(COOKIE_NAME)?.value;

  if (sessionToken) {
    try {
      await callInternalApi('POST', '/auth/logout', { sessionToken });
    } catch {
      // Logout-Fehler ignorieren – Cookie wird trotzdem gelöscht
    }
    // D-004: Alle CSRF-Token der Session serverseitig widerrufen.
    try {
      await callInternalApi('DELETE', '/csrf', { sessionToken });
    } catch {
      // Idempotent – Fehler hier sind nicht sicherheitskritisch.
    }
  }

  // Cookie löschen
  await clearSessionCookie();
  await clearCsrfCookie();

  redirect('/login');
}
